// extracted by mini-css-extract-plugin
export const title = "legal-module--title--2gZAx";